import React, {useState} from 'react';
import {inject, observer} from 'mobx-react';
import {RouteComponentProps} from 'react-router-dom';
import {UserStoreTypes} from '@/stores/user';
import {View, Input, Button, Typography} from '@/components';
import { CodeInput } from '@/components/Input'
import {Row, Col, message} from 'antd'
import useReactRouter from 'use-react-router';
import {checkListEnum, createCheckIterator, run} from '@/utils/RegExps';
import log from '@/utils/log';
import {useEffectOnce} from 'react-use';

export interface PropsType {
    UserStore: UserStoreTypes;
}

type SignInProps = PropsType & RouteComponentProps;

export const Forget: React.FC<SignInProps> = inject('UserStore')(observer(props => {
  
    const {ForgetStore} = props.UserStore.AccountStore;
  
    const [password, setPassword] = useState('')
  
    const {history} = useReactRouter();
  
    const handleInputOnChange = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
        ForgetStore.setUserAccount({[key]: e.target.value})
    }
  
    const handleSignInOnClick = () => {
        history.push('/')
    }
  
    const handleForgetOnClick = async () => {
      log({pageId: 'P03', eventId: 'E0302',ext: ''})
      
      const checkList = [checkListEnum.mobile, checkListEnum.code,checkListEnum.password,]
        const status = createCheckIterator(checkList, ForgetStore.userAccount)
        const result= run(status, checkList);
        if (!result.done) return;
        if (ForgetStore.userAccount.password !== password) {
            message.error('两次密码输入不一致')
            return
        }
        await ForgetStore.forget()
    }
  
  useEffectOnce(() => {
    log({pageId: 'P03', eventId: 'E0300',ext: ''})
  })
  
    return (
    <>
      <Row type='flex' justify='space-between' align='middle'>
          <Typography.Title level={1}>忘记密码</Typography.Title>
          <Col><Button onClick={handleSignInOnClick} type="link">立即登录>></Button></Col>
      </Row>
      <Row gutter={[16, 16]}>
          <Col><Input value={ForgetStore.userAccount.mobile} onChange={(e) => handleInputOnChange(e,'mobile')} size='large' placeholder='请输入您的手机号' /></Col>
          <Col><CodeInput value={ForgetStore.userAccount.code} onChange={(e) => handleInputOnChange(e,'code')} phone={ForgetStore.userAccount.mobile} size='large' type={2}  placeholder='请输入验证码' /></Col>
          <Col><Input value={ForgetStore.userAccount.password} onChange={(e) => handleInputOnChange(e,'password')}  size='large' type='password' placeholder='请输入密码' /></Col>
          <Col><Input value={password} onChange={(e) => setPassword(e.target.value)} size='large' type='password' placeholder='请输入密码' /></Col>
          <Col><Button onClick={handleForgetOnClick} type="primary" size='xl' block>确定</Button></Col>
      </Row>
    </>
    )
  
}))

export default View.AccountView(Forget);
